<!--
 * @Author: 朱占伟
 * @LastEditors: 邱扬
 * @description: 选择国家插件
 * @Date: 2021-07-27 14:20:13
 * @LastEditTime: 2021-09-24 14:08:29
-->

<template>
  <div v-if="state.isShow" class="selectCountry">
    <Header :config="headConfig" />
    <div class="selectCountry-box">
      <div class="vant-mt-height" />
      <van-search
        v-model="state.value"
        class="vant-search-box"
        maxlength="28"
        :show-action="!!state.value"
        :placeholder="config.placeholder"
        action-text="cancel"
        @update:model-value="onSearch"
        @cancel="onCancel"
      />

      <div v-if="!state.value" class="selectCountry-list">
        <van-index-bar :index-list="state.nameList || []">
          <van-cell
            v-if="orderType==='aso'"
            style="margin-top:8px"
            key="no"
            title="(no app)"
            @click="saveCountry('no')"
          />
          <div v-for="(item, index) in state.list" :key="index">
            <van-index-anchor :index="item[0]" />
            <van-cell
              v-for="val in item[1]"
              :key="val.name"
              :title="val.name"
              @click="saveCountry(val)"
            >
              <!-- 使用 right-icon 插槽来自定义右侧图标 -->
              <template #icon>
                <span class="icon-flag icon-img" :class="val.icon" />
              </template>
            </van-cell>
          </div>
        </van-index-bar>
      </div>

      <div v-else class="selectCountry-list">

        <van-list v-if="state.resList.length">
          <van-cell
            v-for="val in state.resList"
            :key="val.name"
            :title="val.name"
            @click="saveCountry(val)"
          >
            <template #icon>
              <span class="icon-flag icon-img" :class="val.icon" />
            </template>
          </van-cell>
        </van-list>

        <van-empty v-else image="search" description="No countries searched" />
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, getCurrentInstance ,onMounted,onBeforeMount,ref} from 'vue';
import { getCountry,sortWord } from 'model/common';
import event from 'utils/eventBus';
import { EVENTS } from 'src/config/event.config.js';
export default {
  props: {
    config: {
      type: Object,
      default: () => {
        return {
          placeholder: 'Please select a Country/Region', // 搜索占位符
          eventName: 'getCountry' // 暴露给父级监听数据的方法名
        };
      }
    },
    platform: {
      type: Number,
      default: null
    },
    orderType:{
      type:String,
      default:null
    }
  },
  setup(props, { emit }) {
    const key = 'COUNSTRY';
    let copyList = []; // 备用国家列表

   
    const headConfig = {
      callBackName:EVENTS.COUNTRY_BACK,
      type: 'other',
      title: 'Country/Region'
    };
    const state = reactive({
      resList: [], // 搜索结果list
      list: [], // 国家列表
      nameList: [], // 标签列表
      value: '' ,// 搜索的值
      isShow:false,
    });

    const instance = getCurrentInstance();

    // 接口管理
    const api = instance.appContext.config.globalProperties.$url;
    // 搜索国家
    const onSearch = (val) => {
      let tem = JSON.parse(JSON.stringify(copyList));
      tem = tem.filter((item) => {
        return item.name.toLowerCase().indexOf(val.toLowerCase()) > -1;
      });
      state.resList = [];
      state.resList.push(...tem);
    };

    // 删除国家
    const onCancel = () => {
      state.resList = [];
    };

    // 处理国家数据
    const handleCountry = (data) => {
      const obj = {};
      if (Array.isArray(data)) {
        data.forEach((item) => {
          const key = item.name && item.name.charAt(0);
          const val = {
            country: item.country,
            icon: item.icon,
            name: item.name,
            gmt: item.gmt,
            google: item.google,
            ios: item.ios,
            sign:item.sign
          };
          if (!obj[key]) {
            obj[key] = [val];
          } else {
            obj[key].push(val);
          }
        });
      }
      return obj;
    };

    // 获取国家数据
    const queryCountry = async() => {
      const re = await getCountry(api.POST_COUNTRY_LIST);
      let data = [];
      if (+re.code === 0) {
        data = re.data || [];
      }
      localStorage.setItem(key, JSON.stringify(data));
      return data;
    };

    //根据platform筛选国家,Google或者iOS属性必须有一个是true
    const filterdCountryList=(list)=>{
      const countryList=ref([])
      list.forEach((item)=>{
        if (props.platform===1&&item.google===true) {
          countryList.value.push(item)
        } else if(props.platform===2&&item.ios===true){
          countryList.value.push(item)
        }else if(props.platform===null&&(item.ios!==false||item.google!==false)){
          countryList.value.push(item)
        }   
      })
      return countryList.value
    }
    
    // init
    const init = async() => {
      state.resList=[]
      state.list=[]
      state.nameList=[]
      state.value=''

      const data = await queryCountry();
      const tem = sortWord(handleCountry(data));
      state.list = (tem && Object.entries(tem)) || [];
      state.nameList = (tem && Object.keys(tem)) || [];
      copyList = JSON.parse(JSON.stringify(data));
    };

    // 选择国家
    const saveCountry = (val) => {
      emit(props.config.eventName, val);
      state.isShow = false
    };

    //展示页面
    const openBox = ()=>{
      state.isShow = true
      // 初始化操作
      const datas = JSON.parse(localStorage.getItem(key)) || null;
      init(datas);
    }

    
    

    onMounted(() => {
      event.$on(EVENTS.COUNTRY_BACK, () => {
        state.isShow = false
      });
    });
    onBeforeMount(()=>{
      event.$off(EVENTS.COUNTRY_BACK)
    })
    return { headConfig,openBox,saveCountry, queryCountry, onSearch, onCancel, state,filterdCountryList };
  }
};
</script>
<style lang="scss" scoped>
@import './css/counstry.icon.scss';
@import './index.scss';
</style>
